import React from 'react';
import { PrivacySection } from '@contest-web/components/src/sections';

function PrivacyApp() {
    return <PrivacySection />
}

export default PrivacyApp;